import { render, staticRenderFns } from "./layer-section-dialog.vue?vue&type=template&id=271d7708&"
import script from "./layer-section-dialog.vue?vue&type=script&lang=js&"
export * from "./layer-section-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports